exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles--fileContainer--Zz75wupK {\r\n  background-color: #DDD;\r\n  border: 2px solid black;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.styles--fileContainer--Zz75wupK > h1 {\r\n  background-color: #BBB;\r\n  padding: 1rem;\r\n  line-height: 1rem;\r\n  margin: 0;\r\n}\r\n\r\n.styles--pagesContainer--1jsz3qzT {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  overflow-x: auto;\r\n  padding: 0.5rem;\r\n  min-height: 150px;\r\n}\r\n\r\n.styles--page--21AsPqGk {\r\n  border: 1px solid black;\r\n  margin: 0.1rem;\r\n  min-height: 150px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"fileContainer": "styles--fileContainer--Zz75wupK",
	"pagesContainer": "styles--pagesContainer--1jsz3qzT",
	"page": "styles--page--21AsPqGk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/Imposer/styles.css
// module id = 995
// module chunks = 1